import {VARIABLES} from '../symbols';

export default function getHostVariables(host) {
	if (!host) return null;

	return host[VARIABLES];
}
